/* eslint-disable react/no-unknown-property */
import React from 'react';

import Item from 'react-scale/components/website/big/open-datasets/shared/interactive-car/Item';
import Tooltip from 'react-scale/components/website/big/open-datasets/shared/interactive-car/ToolTip';

const List = ({ items, onSensorHover, sensorHighlight }) => (
  <ul>
    {items.map(item => (
      <Item
        key={item.type}
        onClick={onSensorHover}
        type={item.type}
        text={item.text}
        number={item.number}
        numberBackground={item.background}
      >
        {item.content && (
          <Tooltip showTooltip={sensorHighlight} content={item.content} type={item.type} />
        )}
      </Item>
    ))}
    <style jsx>{`
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        position: relative;
        z-index: 4;
      }
    `}</style>
  </ul>
);

export default List;
